<ion-content class="login-content" [fullscreen]="true" [scrollY]="false" no-bounce>
  <div class="login-page">
    <div class="login-background"></div>
    <div class="login-container" [class.account-selection-active]="accountSelection">
    <form
      class="login-panel"
      id="login-form"
      (ngSubmit)="signIn()"
      [formGroup]="loginForm"
      [attr.aria-hidden]="accountSelection ? 'true' : null"
      novalidate
    >
      <div class="toolbar-logo login-logo"></div>
      <ion-list class="login-inputs" lines="none">
        <ion-item class="username">
          <ion-input
            id="username"
            type="text"
            class="username username-input"
            formControlName="username"
            autocomplete="username"
            placeholder="Username"
          ></ion-input>
        </ion-item>
        <div class="login-actions-row">
          <ion-item class="password">
            <ion-input
              id="password"
              class="password password-input"
              placeholder="Password"
              type="password"
              formControlName="password"
              autocomplete="current-password"
            ></ion-input>
          </ion-item>
          <button class="primary button login-submit login-button" type="submit">
            Login
          </button>
        </div>
      </ion-list>
    </form>
    <div class="account-selection-overlay" *ngIf="accountSelection">
      <div class="account-selection" role="dialog" aria-modal="true" aria-labelledby="account-selection-title">
        <div class="account-selection-title" id="account-selection-title">Multiple accounts found</div>
        <div class="account-selection-copy">
          {{ accountSelection.selectionReason || accountSelection.message }}
        </div>
        <div class="account-selection-options">
          <button
            class="account-option"
            type="button"
            *ngFor="let account of accountSelection.accountChoices"
            [class.selected]="selectedAccountUserId === account.userId"
            [class.account-option-inactive]="account.userActive === false || account.deleted"
            (click)="selectAccount(account)"
          >
            <span class="account-option-name">
              {{ account.userFirstName || 'Unknown' }} {{ account.userLastName || 'User' }}
            </span>
            <span class="account-option-meta">
              {{ account.username }}
              <span *ngIf="account.userEmail"> · {{ account.userEmail }}</span>
            </span>
            <span class="account-option-status" *ngIf="account.userActive === false || account.deleted">
              Needs review
            </span>
          </button>
        </div>
        <button class="primary button account-selection-submit" type="button" (click)="signInWithSelectedAccount()">
          Continue With Selected Account
        </button>
      </div>
    </div>
      <div class="version-label">v{{ version }}</div>
    </div>
  </div>
</ion-content>
